<div fxLayout="row" fxLayoutAlign="start center">

    <mat-checkbox *ngIf="selectable" [(ngModel)]="selected" (ngModelChange)="onSelectedChange()" class="pl-16 pr-16"
        (click)="$event.stopPropagation();" id="{{'selectNote_' + _note?.id}}" aria-label="Select Note"
        matTooltip="Select Note"></mat-checkbox>

    <!--MRD - PD suggested adding an edit icon but it looks wrong when displayed on the subject dashboard as other widgets do not, so have commented it out.  If we need it just uncomment the following couple of lines-->
    <!-- <button mat-button class="mat-icon-button pl-0 pr-8" (click)="readNote(); $event.stopPropagation();" aria-label="Read Note" matTooltip="Read Note" *ngIf='!selectable'>
        <mat-icon>edit</mat-icon>
    </button> -->

    <div class="info" [ngClass]="{'pl-8': !selectable}" fxFlex FlexLayout="column">

        <div class="row-1" fxLayout="row" fxLayoutAlign="space-between center">

            <div class="pr-32" fxLayout="row wrap" fxFlex fxLayoutAlign="space-between center">
                <div class="name" fxLayout="row" fxLayoutAlign="start center" fxFlex>
                    <div class='id' *ngIf="_link?.sequenceId">{{_link.sequenceId}}</div>
                    <div class='draft' *ngIf="!_link?.sequenceId">Draft</div>
                    <span class="pl-8 text-truncate" *ngIf="_note?.user?.fullName"> - {{_note?.user?.fullName}}</span>
                </div>
                <div fxFlex class="time">{{_note?.dateCreated | date: 'dd/MMM/yyyy - hh:mm a'}}</div>
            </div>

            <div class="actions" fxLayout="row" fxLayoutAlign="start center">
                <button mat-icon-button class="mat-icon-button" (click)="toggleStar($event)" aria-label="Toggle star"
                    fxHide.xs matTooltip="Toggle Starred" [disabled]="readOnly">
                    <mat-icon class="star" *ngIf="_note?.starred">star</mat-icon>
                    <mat-icon *ngIf="!_note?.starred">star_outline</mat-icon>
                </button>
                <button mat-icon-button class="mat-icon-button" (click)="toggleImportant($event)"
                    aria-label="Toggle important" fxHide.xs matTooltip="Toggle Important" [disabled]="readOnly">
                    <mat-icon class="important" *ngIf="_note?.important">error</mat-icon>
                    <mat-icon *ngIf="!_note?.important">error_outline</mat-icon>
                </button>
                <button mat-icon-button class="mat-icon-button" (click)="toggleSensitive($event)"
                    aria-label="Toggle sensitive" fxHide.xs matTooltip="Toggle Sensitive" [disabled]="readOnly">
                    <mat-icon class="sensitive" *ngIf="_note?.sensitive">lock</mat-icon>
                    <mat-icon *ngIf="!_note?.sensitive">lock_open</mat-icon>
                </button>

                <div *ngIf="!readOnly" class="mat-button-wrapper">
                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" class="mat-icon-button"
                        (click)="$event.stopPropagation();" fxHide.xs matTooltip="More"
                        [disabled]="readOnly">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </div>
                <mat-menu #moreMenu="matMenu">
                    <button mat-menu-item aria-label="Copy" [copy-clipboard]="_note?.detail"
                        (copied)="notifyCopied($event)">
                        <mat-icon>assignment</mat-icon>
                        <span>Copy</span>
                    </button>

                    <button mat-menu-item aria-label="Print" (click)="print($event)">
                        <mat-icon>print</mat-icon>
                        <span>Print</span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <div *ngIf="_note?.noteType" fxLayout="row" fxLayoutAlign="start center"
            style="min-height: 0px!important; margin-bottom:7px">
            <div class="w-100-p" fxLayout="column" fxLayoutAlign="start start">
                <div fxFlex class="time">{{_note?.noteType.name || '' }}</div>
            </div>
        </div>

        <div class="row-2" fxLayout="row" fxLayoutAlign="start center">

            <div class="w-100-p" fxLayout="column" fxLayoutAlign="start start">
                <div class="detail text-truncate" *ngIf="_note?.detail">
                    {{_note?.detail | htmlToPlaintext }}
                </div>
            </div>
        </div>
    </div>
</div>